export const dataCAR = [
  {
    id: 1,
    imgUrl: "11.png",
    alt: "siceen21",
    url: "https://sicee.ine.mx/home",
    itemActive: "",
  },
  {
    id: 2,
    imgUrl: "apoyo_ciudadano.png",
    alt: "Apoyo ciudadano",
    url: "https://itetlax.org.mx/assets/img/imgC_AR/apoyo_ciudadano.png",
    itemActive: "",
  },
  {
    id: 3,
    imgUrl: "0.png",
    alt: "Convocatoria OPPMT",
    url: "https://www.observatoriomujerestlaxcala.mx/contents/",
    itemActive: "",
  },
  {
    id: 4,
    imgUrl: "RedMujeres.webp",
    alt: "Red Mujeres (formulario)",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdZb2vkV6LQwamOR7zY3XC_gIHwkq-qbuQoAiWm6rQWQx6Ktg/viewform",
    itemActive: "",
  },
  {
    id: 5,
    imgUrl: "cddlm.jpg",
    alt: "Cartilla de derechos de las mujeres",
    url: "https://www.cartilladerechosdelasmujeres.gob.mx",
    itemActive: "",
  },
  {
    id: 6,
    imgUrl: "ObservadorElectoral.jpeg",
    alt: "",
    url: "https://pe2027-observadores.ine.mx",
    itemActive: "",
  },
  {
    id: 7,
    imgUrl: "SC.png",
    alt: "",
    url: "https://itetlax.org.mx/assets/pdf/convocatorias/Triptico.pdf",
    itemActive: "",
  },
  {
    id: 8,
    imgUrl: "Hackathon_2.png",
    alt: "",
    url: "https://ine.mx/hackathon-2026/",
    itemActive: "",
  },
  {
    id: 9,
    imgUrl: "14OCT.png",
    alt: "",
    url: "https://forms.cloud.microsoft/r/UMPgsDk0Lz",
    itemActive: "active",
  },
  {
    id: 10,
    imgUrl: "20_OCT.png",
    alt: "",
    url: "https://forms.cloud.microsoft/r/AweV4UkLGY",
    itemActive: "",
  },
  {
    id: 11,
    imgUrl: "16OCT.png",
    alt: "",
    url: "https://forms.gle/p95qGjJTpXwj7iS6A",
    itemActive: "",
  },
];

